module.exports = __webpack_public_path__ + "img/my@2x.fc6f3b59.png";